var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.5C15.0938 9.5 16 10.4062 16 11.5V14C16 15.125 15.0938 16 14 16H2C0.875 16 0 15.125 0 14V11.5C0 10.4062 0.875 9.5 2 9.5H3.65625L5.15625 11H2C1.71875 11 1.5 11.25 1.5 11.5V14C1.5 14.2812 1.71875 14.5 2 14.5H14C14.25 14.5 14.5 14.2812 14.5 14V11.5C14.5 11.25 14.25 11 14 11H10.8125L12.3125 9.5H14ZM13.5 12.75C13.5 13.1875 13.1562 13.5 12.75 13.5C12.3125 13.5 12 13.1875 12 12.75C12 12.3438 12.3125 12 12.75 12C13.1562 12 13.5 12.3438 13.5 12.75ZM7.46875 11.5312L3.1875 7.28125C2.875 7 2.875 6.53125 3.1875 6.21875C3.46875 5.9375 3.9375 5.9375 4.25 6.21875L7.25 9.21875V0.75C7.25 0.34375 7.5625 0 8 0C8.40625 0 8.75 0.34375 8.75 0.75V9.21875L11.7188 6.25C12 5.9375 12.4688 5.9375 12.75 6.25C13.0625 6.53125 13.0625 7 12.75 7.28125L8.5 11.5312C8.375 11.6875 8.1875 11.75 8 11.75C7.78125 11.75 7.59375 11.6875 7.46875 11.5312Z",
    fill: "#006699"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.26b92804197790d0f18e020f96a5a4e5.svg";
export { ForwardRef as ReactComponent };